module.exports = __webpack_public_path__ + "static/blue-logo@3x-d5265e3d082774ed29a2b06e3662c138.png";